export { default, type ScreenReaderAnnounceProps } from './ScreenReaderAnnounce';
